'use strict';

var lightDesktop1280;
var hasRequiredLightDesktop1280;

function requireLightDesktop1280 () {
	if (hasRequiredLightDesktop1280) return lightDesktop1280;
	hasRequiredLightDesktop1280 = 1;

	/**
	 * Do not edit directly, this file was auto-generated.
	 */

	lightDesktop1280 = {
	  "theme": "light-desktop1280",
	  "type": {
	    "family": {
	      "base": "Mulish",
	      "decorative": "Besley"
	    }
	  },
	  "borderWeight": {
	    "medium": "2px",
	    "small": "1.5px",
	    "xsmall": "1px"
	  },
	  "column": {
	    "app": {
	      "container": "0px",
	      "gutter": "0px",
	      "margin": "0px"
	    },
	    "web": {
	      "container": "1440px",
	      "gutter": "16px",
	      "margin": "32px"
	    }
	  },
	  "gap": {
	    "0": "0px",
	    "25": "1px",
	    "50": "2px",
	    "100": "4px",
	    "200": "8px",
	    "300": "12px",
	    "400": "16px",
	    "500": "20px",
	    "600": "24px",
	    "800": "32px",
	    "1000": "32px",
	    "1200": "48px",
	    "1600": "64px",
	    "3600": "144px"
	  },
	  "padding": {
	    "dynamic": {
	      "200": "8px",
	      "400": "16px",
	      "600": "24px",
	      "800": "32px",
	      "1000": "40px",
	      "1200": "48px"
	    },
	    "static": {
	      "25": "1px",
	      "50": "2px",
	      "100": "4px",
	      "150": "4px",
	      "200": "8px",
	      "300": "12px",
	      "400": "16px",
	      "500": "20px",
	      "600": "24px",
	      "800": "32px",
	      "1000": "40px",
	      "1200": "48px",
	      "1400": "56px",
	      "1600": "64px",
	      "4125": "0px"
	    }
	  },
	  "radius": {
	    "background": {
	      "large": "16px",
	      "medium": "8px",
	      "rounded": "300px",
	      "small": "4px",
	      "xlarge": "32px",
	      "xsmall": "3px"
	    },
	    "surface": {
	      "large": "16px",
	      "medium": "8px",
	      "small": "4px",
	      "xlarge": "32px"
	    }
	  },
	  "size": {
	    "height": {
	      "25": "1px",
	      "75": "3px",
	      "100": "4px",
	      "150": "6px",
	      "200": "8px",
	      "300": "12px",
	      "350": "14px",
	      "400": "16px",
	      "450": "18px",
	      "475": "19px",
	      "500": "20px",
	      "525": "21px",
	      "600": "24px",
	      "675": "27px",
	      "700": "28px",
	      "800": "32px",
	      "850": "34px",
	      "1000": "40px",
	      "1050": "42px",
	      "1100": "44px",
	      "1300": "52px",
	      "1400": "56px",
	      "1550": "62px",
	      "1600": "64px",
	      "2000": "80px",
	      "2200": "88px",
	      "2750": "110px",
	      "3000": "120px",
	      "3650": "146px",
	      "4000": "160px",
	      "5000": "200px",
	      "5600": "224px",
	      "8375": "335px",
	      "14600": "584px",
	      "146003": "584px"
	    },
	    "width": {
	      "25": "1px",
	      "150": "6px",
	      "200": "8px",
	      "300": "12px",
	      "350": "14px",
	      "400": "16px",
	      "450": "18px",
	      "500": "20px",
	      "600": "24px",
	      "700": "28px",
	      "800": "32px",
	      "850": "34px",
	      "950": "38px",
	      "1000": "40px",
	      "1050": "42px",
	      "1100": "44px",
	      "1300": "52px",
	      "1400": "56px",
	      "1550": "62px",
	      "1600": "64px",
	      "2000": "80px",
	      "2200": "88px",
	      "2350": "94px",
	      "2750": "110px",
	      "3000": "120px",
	      "3650": "146px",
	      "4000": "160px",
	      "5000": "200px",
	      "5250": "210px",
	      "5600": "224px",
	      "6500": "260px",
	      "7500": "300px",
	      "8375": "335px",
	      "14600": "584px"
	    }
	  },
	  "asset": {
	    "blue": {
	      "100": "#f5faff",
	      "200": "#e6f1fc",
	      "300": "#c0d8f0",
	      "400": "#88b1d9",
	      "500": "#5d96cf",
	      "600": "#3971a8",
	      "700": "#21588f",
	      "800": "#194673",
	      "900": "#143657",
	      "background": "#c0d8f0",
	      "backItem": "#5d96cf"
	    },
	    "green": {
	      "100": "#fafffc",
	      "200": "#ebf2ef",
	      "300": "#d1e0d9",
	      "400": "#b6cfc2",
	      "500": "#86b09b",
	      "600": "#307553",
	      "700": "#275e43",
	      "800": "#244c38",
	      "900": "#0f3d26",
	      "background": "#d1e0d9",
	      "backItem": "#86b09b"
	    },
	    "grey": {
	      "100": "#fcfeff",
	      "200": "#f5f7fa",
	      "300": "#e6edf5",
	      "400": "#e6edf5",
	      "500": "#596d84",
	      "600": "#475a70",
	      "700": "#36485c",
	      "800": "#2e3a47",
	      "900": "#212933",
	      "background": "#c8d3e0",
	      "backItem": "#596d84"
	    },
	    "orange": {
	      "100": "#fffaf5",
	      "200": "#fff3e8",
	      "300": "#f3d8c0",
	      "400": "#e7b88f",
	      "500": "#cf8545",
	      "600": "#b4631d",
	      "700": "#8e4d14",
	      "800": "#784213",
	      "900": "#693a11",
	      "background": "#f3d8c0",
	      "backItem": "#cf8545"
	    },
	    "purple": {
	      "100": "#fcfaff",
	      "200": "#f2ecfe",
	      "300": "#d7cee9",
	      "400": "#b9abd5",
	      "500": "#8471ab",
	      "600": "#533e7d",
	      "700": "#3b2566",
	      "800": "#2a174f",
	      "900": "#17043e",
	      "background": "#d7cee9",
	      "backItem": "#8471ab"
	    },
	    "red": {
	      "100": "#fff7f9",
	      "200": "#feeef2",
	      "300": "#f0c4cd",
	      "400": "#e296a6",
	      "500": "#c6516a",
	      "600": "#af2645",
	      "700": "#980b29",
	      "800": "#800d25",
	      "900": "#68182a",
	      "background": "#f0c4cd",
	      "backItem": "#c6516a"
	    },
	    "sand": {
	      "100": "#ffffff",
	      "200": "#f6f1e5",
	      "300": "#e9e1ce",
	      "400": "#d9cdb0",
	      "500": "#c1af86",
	      "600": "#9e8c61",
	      "700": "#72623e",
	      "800": "#5e4d27",
	      "900": "#3e3114",
	      "background": "#e9e1ce",
	      "backItem": "#c1af86"
	    },
	    "shade": {
	      "white": "#ffffff"
	    }
	  },
	  "accent": {
	    "blue": {
	      "backgroundBold": "#3971a8",
	      "backgroundLevel1": "#e6f1fc",
	      "backgroundLevel2": "#c0d8f0",
	      "border": "#3971a8",
	      "icon": "#21588f",
	      "text": "#21588f",
	      "textBold": "#194673"
	    },
	    "green": {
	      "backgroundBold": "#307553",
	      "backgroundLevel1": "#ebf2ef",
	      "backgroundLevel2": "#d1e0d9",
	      "border": "#275e43",
	      "borderBold": "#0f3d26",
	      "icon": "#275e43",
	      "iconBold": "#0f3d26",
	      "text": "#275e43",
	      "textBold": "#244c38"
	    },
	    "orange": {
	      "backgroundBold": "#8e4d14",
	      "backgroundLevel1": "#fff3e8",
	      "backgroundLevel2": "#f3d8c0",
	      "border": "#b4631d",
	      "icon": "#8e4d14",
	      "text": "#8e4d14",
	      "textBold": "#784213"
	    },
	    "purple": {
	      "backgroundBold": "#533e7d",
	      "backgroundLevel1": "#f2ecfe",
	      "backgroundLevel2": "#d7cee9",
	      "border": "#533e7d",
	      "icon": "#3b2566",
	      "text": "#3b2566",
	      "textBold": "#2a174f"
	    },
	    "red": {
	      "backgroundBold": "#af2645",
	      "backgroundLevel1": "#feeef2",
	      "backgroundLevel2": "#f0c4cd",
	      "border": "#af2645",
	      "icon": "#980b29",
	      "text": "#980b29",
	      "textBold": "#800d25"
	    }
	  },
	  "brand": {
	    "apple": {
	      "button": {
	        "border": "#000000",
	        "fill": "#ffffff",
	        "text": "#000000"
	      },
	      "icon": "#000000"
	    },
	    "emerson": {
	      "gold": "#dca270",
	      "silver": "#949494"
	    },
	    "facebook": {
	      "logo": "#3c5a99"
	    },
	    "fullscript": {
	      "logo": {
	        "leaf": "#88b04b",
	        "wordmark": "#36485c"
	      }
	    },
	    "google": {
	      "button": {
	        "border": "#000000",
	        "fill": "#ffffff",
	        "text": "#000000"
	      },
	      "icon": {
	        "blue": "#4285f4",
	        "green": "#34a853",
	        "red": "#ea4335",
	        "yellow": "#fbbc05"
	      }
	    },
	    "linkedin": {
	      "logo": "#2867b2"
	    },
	    "twitterX": {
	      "logo": "#000000"
	    }
	  },
	  "critical": {
	    "backgroundBold": "#af2645",
	    "backgroundLevel1": "#feeef2",
	    "backgroundLevel2": "#f0c4cd",
	    "border": "#af2645",
	    "icon": "#980b29",
	    "text": "#980b29",
	    "textBold": "#800d25"
	  },
	  "discovery": {
	    "backgroundBold": "#9e8c61",
	    "backgroundLevel1": "#f6f1e5",
	    "backgroundLevel2": "#e9e1ce",
	    "border": "#9e8c61",
	    "icon": "#72623e",
	    "text": "#72623e",
	    "textBold": "#5e4d27"
	  },
	  "info": {
	    "backgroundBold": "#3971a8",
	    "backgroundLevel1": "#e6f1fc",
	    "backgroundLevel2": "#c0d8f0",
	    "border": "#3971a8",
	    "icon": "#21588f",
	    "text": "#21588f",
	    "textBold": "#194673"
	  },
	  "inverse": {
	    "backgroundBold": "#212933",
	    "backgroundMuted": "#36485c",
	    "border": "#212933",
	    "borderBold": "#ffffff",
	    "icon": "#f5f7fa",
	    "iconBold": "#ffffff",
	    "text": "#f5f7fa",
	    "textBold": "#ffffff"
	  },
	  "neutral": {
	    "backgroundLevel0": "#ffffff",
	    "backgroundLevel1": "#f5f7fa",
	    "backgroundLevel2": "#e6edf5",
	    "backgroundLevel3": "#c8d3e0",
	    "border": "#b8c6d6",
	    "borderBold": "#596d84",
	    "borderMuted": "#f5f7fa",
	    "divider": "#c8d3e0",
	    "icon": "#36485c",
	    "iconBold": "#2e3a47",
	    "text": "#36485c",
	    "textBold": "#2e3a47",
	    "textSubtle": "#475a70",
	    "backgroundLevel02": "#ffffff"
	  },
	  "recur": {
	    "backgroundBold": "#533e7d",
	    "backgroundLevel1": "#f2ecfe",
	    "backgroundLevel2": "#d7cee9",
	    "border": "#533e7d",
	    "icon": "#3b2566",
	    "text": "#3b2566",
	    "textBold": "#2a174f"
	  },
	  "smart": {
	    "backgroundBold1": "#7495b9",
	    "backgroundBold2": "#4d7199",
	    "backgroundBold3": "#2e5988"
	  },
	  "success": {
	    "backgroundBold": "#307553",
	    "backgroundLevel1": "#ebf2ef",
	    "backgroundLevel2": "#d1e0d9",
	    "border": "#307553",
	    "icon": "#275e43",
	    "text": "#275e43",
	    "textBold": "#244c38"
	  },
	  "surface": {
	    "inverse": "#2e3a47",
	    "level0": "#ffffff",
	    "level1": "#f5f7fa",
	    "overflow": "#ffffff",
	    "overlay": "#ffffff",
	    "overlayBackdrop": "#00000033",
	    "overlayInverted": "#2e3a47",
	    "raised": "#ffffff"
	  },
	  "warning": {
	    "backgroundBold": "#8e4d14",
	    "backgroundLevel1": "#fff3e8",
	    "backgroundLevel2": "#f3d8c0",
	    "border": "#b4631d",
	    "icon": "#8e4d14",
	    "text": "#8e4d14",
	    "textBold": "#784213"
	  },
	  "effect": {
	    "blur": {
	      "price": "6px"
	    },
	    "elevation": {
	      "overflow": {
	        "blur": "8px",
	        "colour": "#36485c29",
	        "opacity": "16px",
	        "spread": "0px",
	        "x": "0px",
	        "y": "-2px"
	      },
	      "overflowFade": "#212933",
	      "overlay": {
	        "blur": "16px",
	        "colour": "#36485c29",
	        "opacity": "16px",
	        "spread": "0px",
	        "x": "0px",
	        "y": "4px"
	      },
	      "raised": {
	        "blur": "6px",
	        "colour": "#36485c29",
	        "opacity": "16px",
	        "spread": "0px",
	        "x": "0px",
	        "y": "2px"
	      }
	    },
	    "focused": {
	      "border": "#015fcc",
	      "stroke": "2px"
	    },
	    "overlay": "#0000001f",
	    "skeleton": {
	      "backgroundLevel0": "#f5f7fa00",
	      "backgroundLevel1": "#e6edf580",
	      "backgroundLevel2": "#c8d3e0",
	      "radius": "4px"
	    },
	    "state": {
	      "disabled": {
	        "opacity": "0.5"
	      },
	      "hovered": {
	        "background": "#00000014",
	        "backgroundBold": "#00000029",
	        "border": "#00000014",
	        "borderBold": "#00000047",
	        "icon": "#00000014",
	        "iconBold": "#00000029",
	        "inverse": {
	          "background": "#ffffff14",
	          "backgroundBold": "#ffffff29",
	          "border": "#ffffff14",
	          "borderBold": "#ffffff47",
	          "icon": "#ffffff14",
	          "text": "#ffffff14"
	        },
	        "text": "#00000014",
	        "textBold": "#00000029"
	      },
	      "pressed": {
	        "background": "#00000029",
	        "backgroundBold": "#00000047",
	        "border": "#00000029",
	        "borderBold": "#000000cc",
	        "icon": "#00000029",
	        "iconBold": "#00000047",
	        "inverse": {
	          "background": "#ffffff29",
	          "backgroundBold": "#ffffff47",
	          "border": "#ffffff29",
	          "borderBold": "#ffffffcc",
	          "icon": "#ffffff29",
	          "text": "#ffffff29"
	        },
	        "text": "#00000029",
	        "textBold": "#00000047"
	      },
	      "readOnly": {
	        "opacity": "0.8"
	      },
	      "shortPressed": {
	        "opacity": "0.7"
	      }
	    }
	  },
	  "typography": {
	    "letterSpacing": {
	      "body": "-0.2px",
	      "callout": "-0.2px",
	      "caption": "0px",
	      "footnote": "-0.1px",
	      "h1": "-0.4px",
	      "h2": "-0.4px",
	      "h3": "-0.4px",
	      "h4": "-0.4px",
	      "h5": "-0.4px",
	      "smallest": "0.1px",
	      "subcaption": "0.1px"
	    },
	    "lineHeight": {
	      "body": "24px",
	      "callout": "20px",
	      "caption": "16px",
	      "footnote": "20px",
	      "h1": "40px",
	      "h2": "32px",
	      "h3": "32px",
	      "h4": "24px",
	      "h5": "24px",
	      "smallest": "18px",
	      "subcaption": "16px"
	    },
	    "textSize": {
	      "body": "16px",
	      "callout": "15px",
	      "caption": "12px",
	      "footnote": "13px",
	      "h1": "27px",
	      "h2": "24px",
	      "h3": "22px",
	      "h4": "19px",
	      "h5": "17px",
	      "smallest": "9px",
	      "subcaption": "11px"
	    }
	  },
	  "weight": {
	    "bold": "700",
	    "medium": "500",
	    "regular": "400",
	    "semibold": "600"
	  },
	  "accordion": {
	    "border": "#b8c6d6",
	    "borderRadius": "8px",
	    "gapX": "12px",
	    "gapY": "8px",
	    "paddingX": "16px",
	    "paddingY": "8px",
	    "showMoreButton": {
	      "gap": "8px",
	      "paddingX": "12px"
	    },
	    "showMore": {
	      "gap": "8px"
	    },
	    "text": "#2e3a47"
	  },
	  "actionTile": {
	    "accentGreen": {
	      "background": "#ebf2ef",
	      "border": "#275e43",
	      "textBody": "#275e43",
	      "textHeading": "#244c38"
	    },
	    "alternate": {
	      "background": "#ffffff"
	    },
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": "16px",
	    "neutral": {
	      "background": "#f5f7fa",
	      "border": "#b8c6d6"
	    },
	    "paddingX": "16px",
	    "paddingY": "16px",
	    "textBody": "#36485c",
	    "textHeading": "#2e3a47"
	  },
	  "attachment": {
	    "border": "#b8c6d6",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": {
	      "medium": "16px",
	      "small": "8px"
	    },
	    "paddingX": "8px",
	    "paddingY": "8px",
	    "text": "#2e3a47"
	  },
	  "avatar": {
	    "backgroundAvatar": "#e6edf5",
	    "backgroundWellevate": "#e6f1fc",
	    "border": "#ffffff",
	    "borderWeight": "1px",
	    "gap": "8px",
	    "height": {
	      "large": "120px",
	      "medium": "80px",
	      "small": "56px",
	      "xlarge": "160px",
	      "xsmall": "40px"
	    },
	    "icon": {
	      "background": "#36485c",
	      "height": "34px",
	      "iconInverse": "#f5f7fa",
	      "iconNeutral": "#36485c",
	      "width": "34px"
	    },
	    "radius": "300px",
	    "text": "#2e3a47",
	    "width": {
	      "large": "120px",
	      "medium": "80px",
	      "small": "56px",
	      "xlarge": "160px",
	      "xsmall": "40px"
	    }
	  },
	  "badge": {
	    "critical": {
	      "background": "#af2645",
	      "text": "#f5f7fa"
	    },
	    "height": {
	      "medium": "20px",
	      "small": "12px",
	      "xsmall": "8px"
	    },
	    "inverse": {
	      "background": "#e6edf5",
	      "text": "#36485c"
	    },
	    "neutral": {
	      "background": "#212933",
	      "text": "#f5f7fa"
	    },
	    "paddingX": "4px",
	    "paddingY": "4px",
	    "radius": "300px",
	    "recur": {
	      "background": "#533e7d",
	      "text": "#f5f7fa"
	    },
	    "success": {
	      "background": "#307553",
	      "text": "#f5f7fa"
	    },
	    "warning": {
	      "background": "#8e4d14",
	      "text": "#f5f7fa"
	    },
	    "width": {
	      "medium": "20px",
	      "small": "12px",
	      "xsmall": "8px"
	    }
	  },
	  "bottomSheet": {
	    "backgroundScrim": "#0000001f",
	    "backgroundSheet": "#ffffff",
	    "gap": {
	      "large": "20px",
	      "medium": "8px",
	      "small": "4px"
	    },
	    "handle": {
	      "background": "#c8d3e0",
	      "borderRadius": "4px",
	      "height": "4px",
	      "width": "44px"
	    },
	    "item": {
	      "borderRadius": "4px",
	      "gap": "12px",
	      "height": "44px",
	      "paddingX": "8px",
	      "paddingY": "12px",
	      "title": "#2e3a47"
	    },
	    "paddingX": {
	      "large": "40px",
	      "medium": "20px",
	      "small": "4px"
	    },
	    "paddingY": {
	      "medium": "20px",
	      "small": "16px"
	    },
	    "radius": "32px",
	    "textSubtitle": "#475a70",
	    "textTitle": "#36485c"
	  },
	  "box": {
	    "alternate": {
	      "background": "#ffffff",
	      "border": "#b8c6d6"
	    },
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "discovery": {
	      "background": "#f6f1e5",
	      "border": "#9e8c61"
	    },
	    "neutral": {
	      "background": "#f5f7fa",
	      "border": "#b8c6d6"
	    },
	    "paddingX": {
	      "large": "32px",
	      "small": "16px",
	      "xsmall": "8px"
	    },
	    "paddingY": {
	      "large": "32px",
	      "small": "16px",
	      "xsmall": "8px"
	    },
	    "recur": {
	      "background": "#f2ecfe",
	      "border": "#533e7d"
	    }
	  },
	  "button": {
	    "borderRadius": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "borderWeight": "1px",
	    "gap": {
	      "medium": "16px",
	      "small": "8px"
	    },
	    "height": {
	      "large": "52px",
	      "medium": "44px",
	      "small": "34px"
	    },
	    "paddingL": "16px",
	    "paddingX": {
	      "small": "16px"
	    },
	    "primary": {
	      "critical": {
	        "background": "#af2645",
	        "icon": "#f5f7fa",
	        "text": "#ffffff"
	      },
	      "inverse": {
	        "background": "#f5f7fa",
	        "border": "#596d84",
	        "icon": "#36485c",
	        "text": "#2e3a47"
	      },
	      "neutral": {
	        "background": "#36485c",
	        "border": "#ffffff",
	        "icon": "#f5f7fa",
	        "text": "#ffffff"
	      },
	      "smart": {
	        "icon": "#f5f7fa",
	        "text": "#ffffff"
	      }
	    },
	    "secondary": {
	      "critical": {
	        "background": "#af2645",
	        "border": "#af2645",
	        "icon": "#980b29",
	        "iconAlt": "#f5f7fa",
	        "text": "#980b29",
	        "textAlt": "#ffffff"
	      },
	      "inverse": {
	        "border": "#f5f7fa",
	        "icon": "#f5f7fa",
	        "text": "#ffffff"
	      },
	      "neutral": {
	        "border": "#212933",
	        "icon": "#36485c",
	        "text": "#2e3a47"
	      },
	      "smart": {
	        "icon": "#36485c",
	        "iconAlt": "#ffffff",
	        "text": "#2e3a47",
	        "textAlt": "#ffffff"
	      }
	    },
	    "ssoButton": {
	      "apple": {
	        "background": "#ffffff",
	        "border": "#000000",
	        "icon": "#000000",
	        "text": "#000000"
	      },
	      "borderWeight": "1px",
	      "gap": "12px",
	      "google": {
	        "background": "#ffffff",
	        "border": "#000000",
	        "icon": {
	          "blue": "#4285f4",
	          "green": "#34a853",
	          "red": "#ea4335",
	          "yellow": "#fbbc05"
	        },
	        "text": "#000000"
	      },
	      "height": "44px",
	      "padding": "16px",
	      "radius": "8px"
	    },
	    "tertiary": {
	      "inverse": {
	        "icon": "#f5f7fa",
	        "text": "#ffffff"
	      },
	      "neutral": {
	        "icon": "#36485c",
	        "text": "#2e3a47"
	      }
	    },
	    "width": {
	      "large": "52px",
	      "medium": "44px",
	      "small": "34px"
	    }
	  },
	  "carousel": {
	    "gap": "12px",
	    "pagination": {
	      "background": {
	        "default": "#c8d3e0",
	        "selected": "#212933"
	      },
	      "gap": "8px",
	      "height": {
	        "medium": "8px",
	        "small": "4px"
	      },
	      "width": {
	        "medium": "28px",
	        "small": "8px"
	      }
	    }
	  },
	  "checkbox": {
	    "background": {
	      "default": "#ffffff",
	      "selected": "#212933"
	    },
	    "border": "#596d84",
	    "borderRadius": "3px",
	    "borderWeight": "1.5px",
	    "gap": "2px",
	    "height": {
	      "large": "34px",
	      "small": "18px"
	    },
	    "icon": "#f5f7fa",
	    "text": "#36485c",
	    "width": {
	      "large": "34px",
	      "small": "18px"
	    }
	  },
	  "chip": {
	    "background": "#ffffff",
	    "border": "#b8c6d6",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": {
	      "small": "8px",
	      "xsmall": "4px"
	    },
	    "height": "34px",
	    "icon": "#36485c",
	    "iconHeight": "16px",
	    "iconWidth": "16px",
	    "multi": {
	      "background": {
	        "selected": "#c8d3e0"
	      }
	    },
	    "paddingL": {
	      "medium": "12px",
	      "small": "8px"
	    },
	    "paddingR": {
	      "medium": "12px",
	      "small": "8px"
	    },
	    "paddingX": "12px",
	    "single": {
	      "background": {
	        "selected": "#36485c"
	      },
	      "text": {
	        "selected": "#f5f7fa"
	      }
	    },
	    "text": "#2e3a47"
	  },
	  "divider": {
	    "border": "#c8d3e0",
	    "borderWeight": "1px",
	    "gap": "16px",
	    "height": "1px",
	    "text": "#475a70"
	  },
	  "drawer": {
	    "background": {
	      "fixed": "#ffffff",
	      "surface": "#ffffff"
	    },
	    "borderRadius": "16px",
	    "gap": {
	      "medium": "16px",
	      "small": "8px"
	    },
	    "paddingL": "8px",
	    "paddingX": "16px",
	    "paddingY": "16px",
	    "textSubtitle": "#36485c",
	    "textTitle": "#2e3a47"
	  },
	  "dropdown": {
	    "borderRadius": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "destructive": {
	      "item": {
	        "icon": "#980b29",
	        "text": "#980b29"
	      }
	    },
	    "gap": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "height": {
	      "medium": "34px"
	    },
	    "neutral": {
	      "icon": "#36485c",
	      "selected": "#c8d3e0",
	      "textBody": "#36485c",
	      "textTitle": "#2e3a47"
	    },
	    "paddingTop": "8px",
	    "paddingX": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "paddingY": {
	      "medium": "8px",
	      "xsmall": "2px"
	    },
	    "surface": "#ffffff"
	  },
	  "emptyState": {
	    "background": "#ffffff",
	    "border": "#b8c6d6",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": {
	      "medium": "16px",
	      "small": "8px"
	    },
	    "paddingX": "40px",
	    "paddingY": "40px",
	    "textBody": "#36485c",
	    "textHeading": "#2e3a47"
	  },
	  "footers": {
	    "background": "#ffffff",
	    "gap": {
	      "large": "32px",
	      "medium": "16px",
	      "small": "8px",
	      "xlarge": "48px",
	      "xsmall": "4px",
	      "xxlarge": "144px"
	    },
	    "icon": "#36485c",
	    "paddingX": {
	      "large": "32px",
	      "medium": "20px",
	      "small": "16px"
	    },
	    "paddingY": "16px",
	    "text": "#36485c"
	  },
	  "icon": {
	    "alternate": {
	      "background": "#ffffff",
	      "icon": "#36485c"
	    },
	    "backgroundHeight": {
	      "large": "64px",
	      "medium": "52px",
	      "small": "44px",
	      "xsmall": "34px"
	    },
	    "backgroundWidth": {
	      "large": "64px",
	      "medium": "52px",
	      "small": "44px",
	      "xsmall": "34px"
	    },
	    "borderRadius": {
	      "circular": "300px",
	      "rectangular": "8px"
	    },
	    "critical": {
	      "background": "#f0c4cd",
	      "icon": "#980b29"
	    },
	    "discovery": {
	      "background": "#e9e1ce",
	      "icon": "#72623e"
	    },
	    "iconHeight": {
	      "large": "24px",
	      "medium": "20px",
	      "small": "16px",
	      "xsmall": "14px"
	    },
	    "iconWidth": {
	      "large": "24px",
	      "medium": "20px",
	      "small": "16px",
	      "xsmall": "14px"
	    },
	    "info": {
	      "background": "#c0d8f0",
	      "icon": "#21588f"
	    },
	    "inverse": {
	      "background": "#36485c",
	      "icon": "#f5f7fa"
	    },
	    "neutral": {
	      "background": "#e6edf5",
	      "icon": "#36485c"
	    },
	    "recur": {
	      "background": "#d7cee9",
	      "icon": "#3b2566"
	    },
	    "success": {
	      "background": "#d1e0d9",
	      "icon": "#275e43"
	    },
	    "warning": {
	      "background": "#f3d8c0",
	      "icon": "#8e4d14"
	    }
	  },
	  "iconInteractive": {
	    "backgroundHeight": {
	      "large": "34px",
	      "medium": "24px",
	      "small": "20px"
	    },
	    "backgroundWidth": {
	      "large": "34px",
	      "medium": "24px",
	      "small": "20px"
	    },
	    "borderRadius": "300px",
	    "icon": "#36485c"
	  },
	  "input": {
	    "background": "#ffffff",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "critical": {
	      "border": "#af2645",
	      "icon": "#980b29",
	      "text": "#980b29"
	    },
	    "gap": "16px",
	    "height": {
	      "large": "52px",
	      "small": "28px",
	      "xlarge": "80px"
	    },
	    "iconHeight": "24px",
	    "iconWidth": "24px",
	    "neutral": {
	      "border": "#b8c6d6",
	      "icon": "#36485c",
	      "text": "#36485c"
	    },
	    "paddingX": "16px",
	    "paddingY": "16px"
	  },
	  "link": {
	    "accentGreen": {
	      "border": "#275e43",
	      "icon": "#275e43",
	      "text": "#275e43"
	    },
	    "borderRadius": "4px",
	    "gap": "4px",
	    "height": {
	      "small": "3px",
	      "xsmall": "1px"
	    },
	    "inverse": {
	      "border": "#f5f7fa",
	      "icon": "#f5f7fa",
	      "text": "#f5f7fa"
	    },
	    "neutral": {
	      "border": "#36485c",
	      "icon": "#36485c",
	      "text": "#36485c"
	    },
	    "paddingX": "2px",
	    "paddingY": "2px"
	  },
	  "list": {
	    "height": "34px",
	    "padding": {
	      "small": "4px"
	    },
	    "paddingY": {
	      "small": "2px"
	    }
	  },
	  "message": {
	    "borderRadius": "8px",
	    "critical": {
	      "background": "#f0c4cd",
	      "icon": "#980b29",
	      "textBody": "#980b29",
	      "textHeading": "#800d25"
	    },
	    "gap": {
	      "medium": "16px",
	      "small": "8px"
	    },
	    "iconHeight": "24px",
	    "iconWidth": "24px",
	    "info": {
	      "background": "#c0d8f0",
	      "icon": "#21588f",
	      "textBody": "#21588f",
	      "textHeading": "#194673"
	    },
	    "neutral": {
	      "background": "#e6edf5",
	      "icon": "#36485c",
	      "textBody": "#36485c",
	      "textHeading": "#2e3a47"
	    },
	    "paddingX": "16px",
	    "paddingY": "16px",
	    "success": {
	      "background": "#d1e0d9",
	      "icon": "#275e43",
	      "textBody": "#275e43",
	      "textHeading": "#244c38"
	    },
	    "warning": {
	      "background": "#f3d8c0",
	      "icon": "#8e4d14",
	      "textBody": "#8e4d14",
	      "textHeading": "#784213"
	    }
	  },
	  "modal": {
	    "background": {
	      "fixed": "#ffffff",
	      "surface": "#ffffff"
	    },
	    "borderRadius": "16px",
	    "gap": {
	      "medium": "16px",
	      "small": "8px"
	    },
	    "paddingB": "24px",
	    "paddingT": "8px",
	    "paddingX": "24px",
	    "paddingY": "16px",
	    "textBody": "#36485c",
	    "textHeading": "#2e3a47"
	  },
	  "navigation": {
	    "background": {
	      "fixed": "#ffffff",
	      "static": "#ffffff"
	    },
	    "burger": {
	      "borderRadius": "4px",
	      "height": "24px",
	      "width": "24px"
	    },
	    "data": "#475a70",
	    "gap": {
	      "large": "12px",
	      "medium": "8px",
	      "xlarge": "16px",
	      "xsmall": "4px"
	    },
	    "height": "52px",
	    "paddingT": "16px",
	    "paddingX": {
	      "medium": "16px",
	      "small": "12px",
	      "xsmall": "4px"
	    },
	    "paddingY": {
	      "medium": "16px",
	      "small": "12px",
	      "xsmall": "4px"
	    },
	    "text": "#2e3a47"
	  },
	  "page": {
	    "gap": {
	      "large": "20px",
	      "medium": "16px",
	      "small": "8px",
	      "xlarge": "32px",
	      "xsmall": "4px"
	    },
	    "height": "64px",
	    "paddingB": "16px",
	    "paddingT": {
	      "medium": "16px",
	      "small": "12px"
	    },
	    "paddingX": {
	      "large": "32px",
	      "medium": "20px",
	      "small": "16px"
	    },
	    "paddingY": {
	      "medium": "16px",
	      "small": "12px"
	    },
	    "textBody": "#36485c",
	    "textHeading": "#2e3a47"
	  },
	  "pagination": {
	    "gap": "16px"
	  },
	  "pill": {
	    "critical": {
	      "background": "#f0c4cd",
	      "text": "#980b29"
	    },
	    "discovery": {
	      "background": "#e9e1ce",
	      "text": "#72623e"
	    },
	    "gap": "4px",
	    "height": {
	      "medium": "28px",
	      "small": "24px",
	      "xsmall": "16px"
	    },
	    "info": {
	      "background": "#c0d8f0",
	      "text": "#21588f"
	    },
	    "neutral": {
	      "background": "#e6edf5",
	      "text": "#36485c"
	    },
	    "paddingX": {
	      "medium": "12px",
	      "small": "8px",
	      "xsmall": "4px"
	    },
	    "radius": "300px",
	    "recur": {
	      "background": "#d7cee9",
	      "text": "#3b2566"
	    },
	    "success": {
	      "background": "#d1e0d9",
	      "text": "#275e43"
	    },
	    "warning": {
	      "background": "#f3d8c0",
	      "text": "#8e4d14"
	    },
	    "width": {
	      "small": "24px"
	    }
	  },
	  "popover": {
	    "background": "#ffffff",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": {
	      "medium": "32px",
	      "small": "16px"
	    },
	    "height": "12px",
	    "paddingT": "2px",
	    "paddingX": "16px",
	    "paddingY": "16px",
	    "textBody": "#36485c",
	    "textHeading": "#2e3a47",
	    "width": "20px"
	  },
	  "price": {
	    "divider": "#c8d3e0",
	    "gap": "4px",
	    "textDiscount": "#275e43",
	    "textRegular": "#2e3a47",
	    "textSubtle": "#475a70",
	    "wholesale": {
	      "divider": {
	        "height": "14px"
	      }
	    }
	  },
	  "productCard": {
	    "background": {
	      "selected": "#f5f7fa"
	    },
	    "borderRadius": "8px",
	    "data": "#475a70",
	    "gap": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "heading": "#2e3a47",
	    "height": {
	      "medium": "24px"
	    },
	    "icon": "#36485c",
	    "paddingX": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "paddingY": {
	      "large": "12px",
	      "medium": "8px",
	      "small": "4px"
	    },
	    "subheading": "#475a70",
	    "description": "#36485c"
	  },
	  "productImage": {
	    "background": "#ffffff",
	    "border": "#b8c6d6",
	    "borderWeight": "2px",
	    "fSbadge": {
	      "background": "#ebf2ef",
	      "gap": "8px",
	      "heightBackground": {
	        "medium": "24px",
	        "small": "16px"
	      },
	      "heightIcon": {
	        "medium": "12px",
	        "small": "8px"
	      },
	      "heightImage": {
	        "large": "146px",
	        "medium": "110px",
	        "small": "88px",
	        "xlarge": "224px",
	        "xsmall": "62px",
	        "xxlarge": "584px",
	        "xxsmall": "42px"
	      },
	      "icon": "#275e43",
	      "paddingY": "12px",
	      "widthBackground": {
	        "medium": "24px",
	        "small": "16px"
	      },
	      "widthIcon": {
	        "medium": "12px",
	        "small": "8px"
	      },
	      "widthImage": {
	        "large": "146px",
	        "medium": "110px",
	        "small": "88px",
	        "xlarge": "224px",
	        "xsmall": "62px",
	        "xxlarge": "584px",
	        "xxsmall": "42px"
	      }
	    },
	    "padding": "4px",
	    "radius": {
	      "large": "300px",
	      "medium": "16px",
	      "small": "8px",
	      "xsmall": "4px"
	    },
	    "status": {
	      "critical": "#feeef2",
	      "neutral": "#f5f7fa",
	      "warning": "#fff3e8"
	    },
	    "text": "#275e43"
	  },
	  "progressbar": {
	    "background": {
	      "complete": "#307553",
	      "incomplete": "#c8d3e0",
	      "progress": "#36485c"
	    },
	    "borderRadius": "300px",
	    "height": "8px"
	  },
	  "quantitySelector": {
	    "borderRadius": "8px",
	    "height": {
	      "medium": "44px",
	      "small": "34px"
	    },
	    "icon": "#36485c",
	    "number": {
	      "gap": "4px",
	      "width": "38px"
	    }
	  },
	  "radio": {
	    "background": {
	      "default": "#ffffff",
	      "selected": "#212933"
	    },
	    "border": "#596d84",
	    "borderRadius": "300px",
	    "borderWeight": "1.5px",
	    "gap": "2px",
	    "height": {
	      "large": "34px",
	      "small": "20px"
	    },
	    "text": "#36485c",
	    "width": {
	      "large": "34px",
	      "small": "20px"
	    }
	  },
	  "scrollBar": {
	    "paddingRight": "6px"
	  },
	  "search": {
	    "background": "#ffffff",
	    "border": "#b8c6d6",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": "8px",
	    "height": {
	      "large": "52px",
	      "medium": "44px"
	    },
	    "icon": "#36485c",
	    "iconHeight": "24px",
	    "iconWidth": "24px",
	    "paddingX": "16px",
	    "text": "#36485c"
	  },
	  "selectableTile": {
	    "background": {
	      "selected": "#e6edf5",
	      "unselected": "#ffffff"
	    },
	    "border": "#b8c6d6",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": "16px",
	    "paddingT": "4px",
	    "paddingX": "16px",
	    "paddingY": "16px",
	    "text": "#36485c"
	  },
	  "slot": {
	    "border": "#b8c6d6",
	    "icon": "#36485c",
	    "text": "#2e3a47"
	  },
	  "snackbar": {
	    "borderRadius": "8px",
	    "critical": {
	      "surface": "#af2645"
	    },
	    "gap": "16px",
	    "height": "56px",
	    "icon": "#f5f7fa",
	    "paddingT": "2px",
	    "paddingX": "16px",
	    "paddingY": "8px",
	    "success": {
	      "surface": "#307553"
	    },
	    "surface": "#212933",
	    "textHeading": "#ffffff"
	  },
	  "spacing": {
	    "gap": {
	      "large": "24px",
	      "medium": "16px",
	      "small": "8px",
	      "xlarge": "32px",
	      "xsmall": "4px",
	      "xxlarge": "48px"
	    },
	    "padding": {
	      "large": "32px",
	      "small": "16px",
	      "xsmall": "8px"
	    }
	  },
	  "status": {
	    "borderRadius": "4px",
	    "critical": {
	      "background": "#f0c4cd",
	      "icon": "#980b29",
	      "text": "#800d25"
	    },
	    "gap": "8px",
	    "height": {
	      "large": "52px",
	      "medium": "44px",
	      "small": "34px"
	    },
	    "icon": {
	      "height": "8px",
	      "radius": "300px",
	      "width": "8px"
	    },
	    "info": {
	      "background": "#c0d8f0",
	      "icon": "#21588f",
	      "text": "#194673"
	    },
	    "neutral": {
	      "background": "#e6edf5",
	      "icon": "#36485c",
	      "text": "#2e3a47"
	    },
	    "paddingX": {
	      "large": "16px",
	      "medium": "16px",
	      "small": "8px"
	    },
	    "success": {
	      "background": "#d1e0d9",
	      "icon": "#275e43",
	      "text": "#244c38"
	    },
	    "warning": {
	      "background": "#f3d8c0",
	      "icon": "#8e4d14",
	      "text": "#784213"
	    }
	  },
	  "stepper": {
	    "background": {
	      "complete": "#307553",
	      "error": "#af2645"
	    },
	    "border": {
	      "active": "#307553",
	      "incomplete": "#b8c6d6"
	    },
	    "borderRadius": "300px",
	    "circle": {
	      "height": "20px",
	      "width": "20px"
	    },
	    "gap": "0px",
	    "label": "#36485c",
	    "paddingX": "4px"
	  },
	  "table": {
	    "background": {
	      "header": "#e6edf5",
	      "row": "#f5f7fa",
	      "selected": "#f5f7fa"
	    },
	    "border": "#c8d3e0",
	    "cell": {
	      "height": {
	        "min": "44px"
	      },
	      "paddingX": "12px",
	      "paddingY": {
	        "medium": "12px",
	        "small": "4px"
	      },
	      "width": {
	        "min": "88px"
	      }
	    },
	    "gap": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "label": "#2e3a47",
	    "paddingY": {
	      "large": "24px",
	      "small": "8px"
	    },
	    "text": "#36485c"
	  },
	  "tabs": {
	    "background": "#e6edf5",
	    "borderRadius": {
	      "medium": "8px"
	    },
	    "gap": "4px",
	    "paddingX": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "paddingY": {
	      "small": "4px"
	    },
	    "selected": {
	      "background": "#ffffff",
	      "text": "#2e3a47"
	    },
	    "unselected": {
	      "text": "#36485c"
	    }
	  },
	  "toggle": {
	    "button": {
	      "colour": "#ffffff",
	      "height": "24px",
	      "paddingX": "2px",
	      "paddingY": "2px",
	      "width": "24px"
	    },
	    "gap": "12px",
	    "icon": {
	      "height": "16px",
	      "icon": "#2e3a47",
	      "width": "16px"
	    },
	    "radius": "300px",
	    "text": "#36485c",
	    "track": {
	      "backgroundOff": "#c8d3e0",
	      "backgroundOn": "#307553",
	      "height": "32px",
	      "track": "52px"
	    }
	  },
	  "tooltip": {
	    "borderRadius": "4px",
	    "height": "8px",
	    "inverse": {
	      "background": "#f5f7fa",
	      "text": "#36485c"
	    },
	    "neutral": {
	      "background": "#212933",
	      "text": "#f5f7fa"
	    },
	    "paddingX": "8px",
	    "paddingY": "4px",
	    "width": "12px"
	  },
	  "user": {
	    "gap": {
	      "large": "16px",
	      "medium": "8px",
	      "small": "2px"
	    },
	    "paddingX": "2px",
	    "radius": "4px",
	    "textInverse": "#f5f7fa",
	    "textNeutral": "#36485c",
	    "widthMin": {
	      "large": "300px",
	      "medium": "260px",
	      "small": "210px"
	    }
	  }
	};
	
	return lightDesktop1280;
}

exports.__require = requireLightDesktop1280;
//# sourceMappingURL=light-desktop1280.cjs.map
